import React from 'react';
import { Link, useOutletContext } from 'react-router-dom';
import { ROUTES } from '../../../constants';
import { useAdmin } from '../AdminContext';

function OverviewPage() {
  const {
    revenueSummary,
    pendingMedia,
    users,
    platformFees,
    notice,
  } = useAdmin();
  const { refreshing, loadDashboard } = useOutletContext();

  const pendingCount = pendingMedia.length;
  const usersCount = users.length;
  const transactionCount = platformFees.length;

  return (
    <>
      <header className="admin-dashboard__header">
        <div>
          <h1 className="admin-dashboard__title">Overview</h1>
          <p className="admin-dashboard__subtitle">
            Platform health at a glance — revenue, users, and items that need attention.
          </p>
        </div>
        <button
          type="button"
          className="admin-dashboard__refresh"
          onClick={() => loadDashboard({ silent: true })}
          disabled={refreshing}
        >
          {refreshing ? 'Refreshing...' : 'Refresh'}
        </button>
      </header>

      {notice && <div className="admin-dashboard__msg admin-dashboard__msg--success">{notice}</div>}

      <section className="admin-dashboard__section">
        <h2 className="admin-dashboard__section-title">Platform Revenue</h2>
        <div className="admin-revenue__cards">
          <div className="admin-revenue__card">
            <div className="admin-revenue__card-label">Total Collected (Spades)</div>
            <div className="admin-revenue__card-value">&#9824; {(revenueSummary.total_spades || 0).toLocaleString()}</div>
          </div>
          <div className="admin-revenue__card">
            <div className="admin-revenue__card-label">Total Collected (USD)</div>
            <div className="admin-revenue__card-value">${Number(revenueSummary.total_usd || 0).toFixed(2)}</div>
          </div>
          <div className="admin-revenue__card">
            <div className="admin-revenue__card-label">Total Transactions</div>
            <div className="admin-revenue__card-value">{(revenueSummary.transaction_count || 0).toLocaleString()}</div>
          </div>
        </div>
      </section>

      <section className="admin-dashboard__section">
        <h2 className="admin-dashboard__section-title">Needs Attention</h2>
        <div className="admin-overview__tiles">
          <Link
            to={ROUTES.ADMIN_MODERATION}
            className={`admin-overview__tile${pendingCount > 0 ? ' admin-overview__tile--alert' : ''}`}
          >
            <div className="admin-overview__tile-label">Pending Moderation</div>
            <div className="admin-overview__tile-value">{pendingCount}</div>
            <div className="admin-overview__tile-hint">
              {pendingCount > 0 ? 'Review now →' : 'All caught up'}
            </div>
          </Link>

          <Link to={ROUTES.ADMIN_USERS} className="admin-overview__tile">
            <div className="admin-overview__tile-label">Total Users</div>
            <div className="admin-overview__tile-value">{usersCount}</div>
            <div className="admin-overview__tile-hint">Manage users →</div>
          </Link>

          <Link to={ROUTES.ADMIN_REVENUE} className="admin-overview__tile">
            <div className="admin-overview__tile-label">Transactions</div>
            <div className="admin-overview__tile-value">{transactionCount}</div>
            <div className="admin-overview__tile-hint">View revenue →</div>
          </Link>
        </div>
      </section>
    </>
  );
}

export default OverviewPage;
